import { FormControlLabel, Switch, SxProps, Theme } from '@mui/material';
import { useField } from 'formik';

interface Props<T extends object> {
    question: T;
    position: number;
    fieldName: keyof T;
    label: string;
    theming?: SxProps<Theme>;
    labelPlacement?: 'bottom' | 'top' | 'end' | 'start';
}

function FieldToggle<T extends object>({
    position,
    fieldName,
    label,
    theming,
    question,
    labelPlacement,
}: Props<T>) {
    const [, , { setValue: setQuestion }] = useField<T>(`questions[${position}]`);

    return (
        <FormControlLabel
            control={
                <Switch
                    value={question?.[fieldName]}
                    checked={!!question?.[fieldName]}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    onChange={(e, checked) =>
                        setQuestion({
                            ...question,
                            [fieldName]: checked,
                        })
                    }
                />
            }
            label={label}
            labelPlacement={labelPlacement}
            sx={theming}
        />
    );
}

export default FieldToggle;
